<template>
  <div>
    <div class="text-search">
      Kết quả tìm kiếm cho từ khóa: "<strong>{{ key }}</strong>"
    </div>
    <div class="row">
      <div
        v-for="(item, $index) in items"
        :key="$index"
        class="col-sm-6 col-md-4 col-lg-4">
        <item-vat-pham :vatpham="item"/>
      </div>
    </div>

    <infinite-loading
      :identifier="infiniteId"
      @infinite="infiniteHandler">
      <div slot="spinner">Đang tìm kiếm...</div>
      <div slot="no-more">Không còn sản phẩm nào!</div>
      <div slot="no-results">Không có sản phẩm nào phù hợp</div>
    </infinite-loading>
  </div>
</template>

<script>
  import ItemVatPham from "../item/ItemVatPham";
  import rf from "../../communicate/RequestFactory";
  import InfiniteLoading from "vue-infinite-loading";
  import {errorToaster} from "../../services/ErrorHandler";

  export default {
    name: "Search",
    components: {
      ItemVatPham,
      InfiniteLoading,
    },
    data() {
      return {
        limit: 10,
        page: 1,
        key: '',
        items: [],
        infiniteId: +new Date(),
      }
    },
    watch: {
      '$route.query.keyword'() {
        if (this.key !== this.$route.query.keyword) {
          this.items = [];
          this.page = 1;
        }
        this.key = this.$route.query.keyword ? this.$route.query.keyword.trim() : '';
        this.infiniteId += 1;
        return false;
      }
    },
    mounted() {
      this.key = this.$route.query.keyword;
      this.infiniteId += 1;
    },
    methods: {
      infiniteHandler($state) {
        this.$Progress.start();
        const data = {
          key: this.key,
          page: this.page,
          limit: this.limit
        };
        rf.getRequest('ItemRequest').searchItem(data).then((res) => {
          if (res.data && res.data.length) {
            this.page += 1;
            this.items.push(...res.data);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.$Progress.finish()
        }).catch(err => {
          this.errors.push(err.message);
          $state.complete();
          this.$Progress.fail();
          errorToaster("Cố vấn Phong Thủy", "Xẩy ra lỗi kết nối")
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
 .text-search {
   margin: 16px 0px;
 }
</style>



// WEBPACK FOOTER //
// src/components/search/Search.vue